export const API_GW_URL="https://api.dev-pettrak.kynetec.com"
export const CLIENT_ID="a5340168-50dc-463f-b557-546ff7638840"
export const ENVIRONMENT="dev"
